import React, { useEffect, useState } from "react";
import { deleteCategorie, getCategories } from "../Services/CategrieApi";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { useOrganisations } from "./../Auth/useOrganisations";
import { getMenuByCategoryId } from "../Services/MenuApi";
import { getOrganisationById } from "../Services/OrganizationApi";
import GifLoader from "../Components/loader";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "../Helpers/Helpers";

function CategoryList() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [filter, setFilter] = useState("");
  const [categorie, setCategorie] = useState([]);
  const [displayedCategory, setDisplayedCategory] = useState();
  const [rand, setRand] = useState(0);
  const [currency, setCurrency] = useState();
  const [loading, setLoading] = useState(true);
  const [
    organisations,
    setOrganisations,
    usedOrganisations,
    setUsedOrganisations,
  ] = useOrganisations();

  const categoryLibelle = (libelle) => {
    if (typeof libelle === "object") {
      return libelle.fr;
    } else {
      return libelle;
    }
  };

  const promptForDelete = (category_id) => {
    swal({
      title: "Etes-vous sûr ?",
      text: "Une fois supprimé, vous le perdrez !",
      icon: "warning",
      buttons: ["Non", "Oui"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteCategorie(category_id).then((res) => {
          if (res && res.data.success) {
            swal("Pouf ! Votre catégorie a été supprimée !", {
              icon: "success",
            });
            setRand(rand + 1);
          } else {
            swal("Erreur lors de la suppression de la catégorie !", {
              icon: "error",
            });
          }
        });
      } else {
        swal("Votre catégorie est en sécurité !");
      }
    });
  };

  useEffect(() => {
    getCategories(usedOrganisations).then((res) => {
      const success = res.data.success;
      if (success === "0") {
        alert("error");
      } else {
        const finalCatList = [];
        setCategorie(res.data.data);
        console.log(categorie);
      }
    });
    getOrganisationById(usedOrganisations).then((res) => {
      const success = res.data.success;
      if (success === "0") {
        alert("error");
      } else {
        setCurrency(res.data.data.currency);
        setLoading(false);
      }
    });
  }, [rand, usedOrganisations]);

  return (
    <section className="content">
      <GifLoader loading={loading} />
      <div className="row">
        <div className="col-8">
          <form>
            <div className="input-group">
              <input
                type="search"
                className="form-control"
                placeholder="Recherche ..."
                aria-label="Search"
                aria-describedby="button-addon2"
                style={{ padding: "10px", marginTop: "9px" }}
                onChange={(e) => setFilter(e.target.value)}
              />
            </div>
          </form>
        </div>

        <div className="col-4">
          <Link
            to={"/categories/add"}
            className="btn btn-success mt-10 d-block text-center"
            style={{ right: "0", float: "right", marginBottom: "20px" }}
          >
            <i className="fa fa-plus mr-5"></i>
            {t("Ajouter")}
          </Link>
        </div>
      </div>
      <div className="row">
        {categorie &&
          categorie.map((value, index) => {
            const titre =
              typeof value.libelle === "object"
                ? value.libelle.fr
                : value.libelle;

            return (
              <>
                {categoryLibelle(value.libelle)
                  .toLowerCase()
                  .includes(filter.toLowerCase()) ? (
                  <div className="col-xxxl-2 col-xl-3 col-lg-4 col-12">
                    <div className="box food-box">
                      <div className="box-body text-center">
                        <div className="menu-item">
                          {/* <Link to={"/categories/" + value._id}> */}
                          <div style={{ position: "relative" }}>
                            <div
                              style={{
                                width: "100%",
                                height: "170px", // Adjust this to your preferred height (e.g., 160px - 200px)
                                overflow: "hidden", // Ensures anything outside the boundaries is cleanly cut off
                                borderRadius: "8px 8px 0 0", // Rounds the top corners to match the card flow
                                display: "block",
                              }}
                            >
                              <img
                                src={getImageUrl(value.logo)}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "images/product/no-image.png";
                                }}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover", // 1. Fills the entire container box
                                  objectPosition: "center", // 2. Keeps the focal point centered while cropping extra edges
                                }}
                                alt={titre}
                              />
                            </div>
                            {value.logo ? (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "calc(100% + 90px)",
                                  backgroundImage:
                                    "url(" +
                                    process.env.REACT_APP_API_BASE_URL +
                                    value.logo +
                                    ")",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                }}
                              ></div>
                            ) : (
                              <></>
                            )}
                          </div>
                          {/* </Link> */}
                        </div>
                        <div className="menu-details text-center">
                          <Link to={"/categories/" + value._id}>
                            <h4 className="mt-20 mb-10">{titre}</h4>
                          </Link>
                        </div>
                        <div className="act-btn d-flex justify-content-between">
                          <div className="text-center mx-5">
                            <button
                              className="waves-effect waves-circle btn btn-circle btn-success-light btn-xs mb-5"
                              data-toggle="modal"
                              data-target="#modal-center"
                              onClick={(e) => setDisplayedCategory(value)}
                            >
                              <i className="fa fa-eye"></i>
                            </button>
                            <small className="d-block">Voir</small>
                          </div>
                          <div className="text-center mx-5">
                            <Link
                              to={"/categories/edit/" + value._id}
                              className="waves-effect waves-circle btn btn-circle btn-info-light btn-xs mb-5"
                            >
                              {/* <h4 className="mb-10 mt-0">
                                {categoryLibelle(value.libelle)}
                              </h4> */}
                              <i className="fa fa-edit"></i>
                            </Link>
                            <small className="d-block">Modifier</small>
                          </div>
                          <div className="text-center mx-5">
                            <button
                              className="waves-effect waves-circle btn btn-circle btn-primary-light btn-xs mb-5"
                              onClick={(e) => promptForDelete(value._id)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                            <small className="d-block">{t("Delete")}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                {/* <button onClick={(e)=> console.log(value.titre)}>test</button> */}
              </>
            );
          })}
      </div>

      {/* Modal */}
      <div className="modal center-modal fade" id="modal-center" tabindex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t("Details de la categorie")}</h5>
              <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <div className="box box-body b-1 text-center no-shadow">
                    <img
                      src={
                        displayedCategory && displayedCategory.logo
                          ? process.env.REACT_APP_API_BASE_URL +
                            displayedCategory.logo
                          : "images/food/sandwich.jpg"
                      }
                      id="product-image"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="clear"></div>
                </div>
                <div className="col-md-8 col-sm-6">
                  <h2 className="box-title mt-0">
                    {displayedCategory &&
                      categoryLibelle(displayedCategory.libelle)}
                  </h2>

                  <p>{displayedCategory && displayedCategory.description}</p>
                </div>
              </div>
            </div>
            {/* <div className="modal-footer modal-footer-uniform">
              <Link>
                <button type="button" className="btn btn-primary float-right">
                  Modifier
                </button>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
      {/* /.modal */}
    </section>
  );
}
export default CategoryList;
